import { Observable } from 'rxjs';

/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MoneyPotValidationNameRequest } from '@api/models/money-pot-validation-name.request';

import { GameValidationNameRequest } from '../models/game-validation-name.request';
import { UserValidationEmailRequest } from '../models/user-validation-email.request';
import { UserValidationNameRequest } from '../models/user-validation-name.request';
import { ValidationResultResponse } from '../models/validation-result.response';
import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

@Injectable()
export class ValidatorsService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	public validateUser(
		body: UserValidationNameRequest | UserValidationEmailRequest,
	): Observable<ValidationResultResponse> {
		return this.http.post<ValidationResultResponse>(
			`${this.config.apiUrl}/api/v2/public/validators/user`,
			body,
		);
	}

	public validateGame(
		body: GameValidationNameRequest,
	): Observable<ValidationResultResponse> {
		return this.http.post<ValidationResultResponse>(
			`${this.config.apiUrl}/api/v2/public/validators/game`,
			body,
		);
	}

	public validateMoneyPot(
		body: MoneyPotValidationNameRequest,
	): Observable<ValidationResultResponse> {
		return this.http.post<ValidationResultResponse>(
			`${this.config.apiUrl}/api/v2/public/validators/money-pot`,
			body,
		);
	}
}
